module.exports = __webpack_public_path__ + "img/img2.db57f8ed.jpg";